export default {
  LOCAL_STORAGE_USER_KEY: 'publisherInfo',
  LOCAL_STORE_API_TOKEN: 'apiToken',
}
